import React, { useRef } from 'react';
import { connect } from "react-redux";
import { Redirect } from 'react-router-dom';

import NavBar from '../navigation/NavBar';

import routes from '../routes';
import { useAuthUser } from './AuthUserContext';

const PrivateRoute = ({
  pathname,
  processing,
  searchPageHeight,
  navBarVertHeight,
  navBarWidth,
  navBarHeight,
  navBarActive,
  finetune
}) => {
  const authUser = useAuthUser();
  const isAuthenticated = authUser !== null;

  const ref = useRef(null);

  if (pathname === "/reserve")
    finetune = navBarVertHeight;
  else if (pathname === "/search")
    finetune = searchPageHeight;
  else
    finetune = window.innerHeight;

  if (ref.current !== null && processing === 1)
    ref.current.style.cursor = 'wait';
  else if (ref.current !== null)
    ref.current.style.cursor = 'default';

  if (isAuthenticated) {
    return (
      <div ref={ref} className='times-new-roman h-100'>
        <div className='flex flex-row-reverse-l flex-column-reverse justify-end justify-start-l' style={{ minHeight: '100vh' }}>
          <div className='flex-auto-l' style={{ height: finetune }}>
            <main className='bg-white pa0-l'>
              {routes}
            </main>
          </div>
          { navBarActive 
            ? <div className='flex-none-l z-4 navbar-container bg-navy-nav'>
                <NavBar />
              </div>
            : <div className='fixed z-4 navbar-container flex-none-l bg-navy-nav' style={{ width: navBarWidth, height: navBarHeight }}>
                <NavBar />
              </div> }
        </div>
      </div>
    );
  } else
    return (
      <Redirect to="/welcome"/>
    );
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps)(PrivateRoute);
